import { ProfilePreviewSkills } from "PFApp/components/profile_preview/parts/profile_preview_skills";
import { useProfilePreview, useProfilePreviewData } from "PFApp/use_profile_preview";
import { Stack } from "PFComponents/containers";
import { LoadingDots } from "PFComponents/loading_dots";
import SidePanel from "PFComponents/side_panel/side_panel";
import { useProfile } from "PFCore/hooks/queries/profile/use_profile";
import { useEffect, useRef, useState } from "react";

import { ProfilePlaceholderInfoBox } from "./parts/profile_placeholder_info_box";
import ProfilePreviewActionButtons from "./parts/profile_preview_action_buttons";
import { ProfilePreviewAvailability } from "./parts/profile_preview_availability";
import ProfilePreviewBasicInfo from "./parts/profile_preview_basic_info";
import { ProfilePreviewContact } from "./parts/profile_preview_contact";
import { ProfilePreviewCustomFields } from "./parts/profile_preview_custom_fields";
import { ProfilePreviewSummary } from "./parts/profile_preview_summary";
import css from "./profile_preview.module.scss";

export const ProfilePreview = () => {
  const { hidePreview, completePreview } = useProfilePreview();
  const {
    data: { id, ready },
    isOpen,
    isClosing,
    index
  } = useProfilePreviewData();

  const profilePreviewRef = useRef<HTMLDivElement>(null);

  const { data: profile, isSuccess } = useProfile(id, {
    enabled: !!(id && isOpen)
  });

  useEffect(() => {
    if (!isSuccess) {
      return;
    }
    completePreview(profile);
  }, [isSuccess, profile]);

  const [masterExpand, setMasterExpand] = useState(false);

  return (
    <div ref={profilePreviewRef}>
      <SidePanel
        show={isOpen}
        size={"medium"}
        title={
          <Stack gap="spacingLg">
            <ProfilePreviewBasicInfo />
            <ProfilePreviewActionButtons />
          </Stack>
        }
        isSidePanelClosing={isClosing}
        onClose={hidePreview}
        fullHeight
        zIndex={index}
      >
        <div className={css.content}>
          {profile?.placeholder && (
            <ProfilePlaceholderInfoBox profile={profile} onProfileDeleted={hidePreview} />
          )}
          <ProfilePreviewContact />
          <ProfilePreviewAvailability />
          <ProfilePreviewSkills masterExpand={masterExpand} setMasterExpand={setMasterExpand} />
          <ProfilePreviewCustomFields only={["grade", "location", "brands", "sectors"]} />
          <ProfilePreviewSummary />

          {!ready && <LoadingDots className={css.loading} />}
        </div>
      </SidePanel>
    </div>
  );
};
